<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.artid"
        :remote-method="getRemoteArtList"
        filterable
        remote
        clearable
        placeholder="搜索品种"
        :loading="artLoading"
        class="filter-item"
        style="margin-right: 10px; width: 300px;"
      >
        <el-option
          v-for="(item,index) in artListOptions"
          :key="item.artid+index"
          :label="item.name"
          :value="item.artid"
        >
          <span style="margin-right: 15px; float: left; font-size: 13px">{{ item.artid }}</span>
          <span style="margin-right: 15px; color: #8492a6; font-size: 13px">[ {{ item.spec }} ]</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
        </el-option>
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
      <el-button
        :loading="downloadLoading"
        class="filter-item"
        type="primary"
        icon="el-icon-download"
        @click="handleDownload"
      >导出
      </el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      ref="dataTable"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      :max-height="clientHeight"
      size="mini"
      @sort-change="sortChange"
      :default-sort="defaultSort"
    >
      <el-table-column align="center" label="品种编码" width="100" sortable="custom" prop="artid">
        <template slot-scope="scope">{{ scope.row.artid }}</template>
      </el-table-column>
      <el-table-column label="品名" align="center" min-width="200" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="批号"
        align="center"
        width="150"
        sortable="custom"
        prop="serial"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">{{ scope.row.serial }}</template>
      </el-table-column>
      <el-table-column label="产家" align="center" min-width="250" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.factory }}</template>
      </el-table-column>
      <el-table-column label="规格" align="center" width="150" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.spec }}</template>
      </el-table-column>
      <el-table-column label="单位" align="center" width="50">
        <template slot-scope="scope">{{ scope.row.unit }}</template>
      </el-table-column>
      <el-table-column label="件装" align="center" width="80">
        <template slot-scope="scope">{{ scope.row.packtotal }}</template>
      </el-table-column>
      <el-table-column label="库存" align="center" width="80">
        <template slot-scope="scope">{{ scope.row.total }}</template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    >
    </pagination>
  </div>
</template>

<script>
import { getStore2, artSearch, getStoreExport2 } from '@/api/flow'
import Pagination from '@/components/Pagination'

export default {
  name: 'StoreDetail',
  components: {
    Pagination
  },

  filters: {},

  data() {
    return {
      clientHeight: '800',
      total: 0,
      list: null,
      allList: null,
      artForm: {},
      artListOptions: [],
      listQuery: {
        artid: null,
        page: 1,
        limit: 10,
        columns: 'artid',
        asc: false
      },
      defaultSort: { prop: 'artid', order: 'descending' }, // 默认排序列
      listLoading: true,
      downloadLoading: false,
      artLoading: false
    }
  },

  created() {
    this.initHeight()
    this.getList()
  },

  mounted() {
    window.addEventListener('resize', this.initHeight)
  },

  methods: {
    initHeight() {
      this.clientHeight = document.documentElement.clientHeight - 240
    },

    getList() {
      this.listLoading = true
      getStore2(this.listQuery)
        .then(response => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },

    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },

    getRemoteArtList(query) {
      if (query !== '') {
        this.artLoading = true
        setTimeout(() => {
          artSearch(query).then(response => {
            this.artLoading = false
            if (!response.data) return
            this.artListOptions = response.data
          })
        }, 1000)
      } else {
        this.listQuery.artid = null
      }
    },

    // 格式化数据
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j]
        })
      )
    },

    // 排序
    sortChange(column) {
      switch (column.order) {
        case 'ascending':
          this.listQuery.columns = column.prop
          this.listQuery.asc = true
          break
        case 'descending':
          this.listQuery.columns = column.prop
          this.listQuery.asc = false
          break
      }
      this.listQuery.page = 1
      this.getList()
    },

    // 导出事件
    handleDownload() {
      this.downloadLoading = true
      getStoreExport2(this.listQuery).then(response => {
        this.allList = response.data
        import('@/vendor/Export2Excel')
          .then(excel => {
            const tHeader = [
              '品种编码',
              '品名',
              '批号',
              '产地',
              '规格',
              '单位',
              '件装',
              '库存'
            ]
            const filterVal = [
              'artid',
              'name',
              'serial',
              'factory',
              'spec',
              'unit',
              'packtotal',
              'total'
            ]
            const data = this.formatJson(filterVal, this.allList)
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: '库存明细'
            })
            this.downloadLoading = false
          })
          .catch(() => {
            this.downloadLoading = false
          })
      })
    }
  }
}
</script>
